export default __webpack_public_path__ + "static/media/print_kouji_3.9cd40b76.svg";